module.exports = __webpack_public_path__ + "img/logo.7bf0c7b8.png";